<template>
    <b-container v-if="bookedEvents.length" class="booked-events-container">
      <b-row class="booked-events-title">
        <b-col>
          <p>BOOKED EVENTS</p>
        </b-col>
      </b-row>
      <b-row class="booked-events-list">
        <div
          v-for="(event, index) in bookedEvents"
          :key="index"
          class="booked-event"
        >
          <router-link
            :to="getRoute(event.url, event.slug)"
            class="to-booked-event"
          >
            <b-row class="booked-events-profile">
              <b-col cols="2" class="pl-1">
                <img v-if="event.banner" :src="event.banner" class="profile-booked-events-img" />
                <img v-if="event.main_banner" :src="event.main_banner" class="profile-booked-events-img" />
              </b-col>
              <b-col cols="10" class="pl-2">
                <p class="profile-booked-events-name">{{ event.name }}</p>
                <p class="profile-booked-events-date">
                  {{ event.city }} •
                  <span
                    v-if="eventMonths(event.start_date, event.end_date)"
                    class="profile-booked-events-date"
                  >
                    {{ $formatDate.getUTCDate(event.start_date) }} -
                {{ $formatDate.getUTCDate(event.end_date) }}
                    {{ $formatDate.getUTCMonth(event.start_date) }}
                  </span>
                  <span v-else class="profile-booked-events-date">
                   {{$formatDate.getUTCDate(event.start_date) }}
                    {{ $formatDate.getUTCMonth(event.start_date) }} -
                   {{$formatDate.getUTCDate(event.end_date) }}
                    {{ $formatDate.getUTCMonth(event.end_date) }}
                  </span>
                </p>
                <p class="profile-booked-events-venue" v-if="event.awards_venue" >{{event.awards_venue}}</p>
                <p class="profile-booked-events-venue" v-if="event.hotel_details">{{event.hotel_details.name}}</p>
              </b-col>
            </b-row>
          </router-link>
          <router-link
          v-if="isMPEnabled(event)"
            :to="{ name: 'meetingPlanner', params: { eventId: event.id, slug: event.slug } }"
          >
            <i class="fas fa-calendar-alt mpIcon"/>
          </router-link>
          <i
            v-else-if="isEvent(event.url) "
            class="fas fa-calendar-alt mpIconInactive"
          />
        </div>
      </b-row>
      <b-row>
        <router-link
          :to="{ name: 'ccAllEvents' }"
          class="all-events button"
          exact
        >
          <button class="btn-def">All Events</button>
        </router-link>
      </b-row>
    </b-container>
    <b-container v-else>
      <b-row class="booked-events-title">
        <b-col>
          <p>BOOKED EVENTS</p>
        </b-col>
      </b-row>
      <b-row class="justify-content-center booked-events-profile"> <p>No Booked Events</p></b-row>
    </b-container>
</template>

<script>
import redirectToMeetingPlanner from '../../utils/mixins/redirectToMeetingPlanner';
import BookedEvents from '../../utils/mixins/BookedEvents';

export default {
  name: 'BookedEvents',
  mixins: [redirectToMeetingPlanner, BookedEvents],

};
</script>

<style scoped src="./css/booked-event.css"></style>
